import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import chatApi from './chat.api';
import { Button } from '@mui/material';

export default function ChatWindow({
  farmId,
  sessionId,
  userId,
  isNewSession,
  onFirstMessageSent,
  isDark,
  currDarkThemeClass,
  onNewChat,
  onHistoryLoaded
}) {
  const [messages, setMessages] = useState([]);
  const [sending, setSending] = useState(false);
  const [hasSentFirstMessage, setHasSentFirstMessage] = useState(false);

  const isUnsavedNewChat = !sessionId && isNewSession;
  




  useEffect(() => {
    if (!sessionId && isNewSession) {
      setMessages([]);
      setHasSentFirstMessage(false);
    }
  }, [sessionId, isNewSession]);



  /* ---------------- Load history (ONLY existing sessions) ---------------- */
  useEffect(() => {
    if (isUnsavedNewChat) return;

  if (!sessionId) return;

    const loadHistory = async () => {
      try {
        const res = await chatApi.getChatHistory({
          farm_id: String(farmId),
          user_id: String(userId),
          session_id: String(sessionId),
          include_archived: true

        });

        const history = res?.data?.messages || [];

        setMessages(
          history.map(m => ({
            role: m.role || m.sender || 'assistant',
            content: m.content || m.message || '',
          }))
        );
        onHistoryLoaded?.();
      } catch (err) {
        console.error(err);
      }
    };

    loadHistory();
  }, [farmId, sessionId, userId, hasSentFirstMessage,isUnsavedNewChat]);

  /* ---------------- Send Message ---------------- */
 
const handleSend = async text => {
  if (!text.trim() || sending) return;

  setSending(true);
  setMessages(prev => [...prev, { role: 'user', content: text }]);

  let currentSessionId = sessionId;

  try {
    //  CREATE SESSION FIRST (CRITICAL)
    if (!currentSessionId) {
      const res = await chatApi.createChat({
        farm_id: String(farmId),
        user_id: String(userId),
      });

      currentSessionId = res.data.session_id;

      // lock session immediately (parent state)
      onFirstMessageSent(currentSessionId);
    }

    // THEN stream
    const res = await chatApi.streamChat({
      farm_id: String(farmId),
      session_id: String(currentSessionId),
      user_id: String(userId),
      message: text,
    });

    let finalText = '';
    if (typeof res.data === 'string') {
      finalText = res.data
        .split('\n')
        .map(line => {
          try {
            return JSON.parse(line);
          } catch {
            return null;
          }
        })
        .filter(e => e?.type === 'token')
        .map(e => e.content)
        .join('');
    }

    //  ADD ASSISTANT MESSAGE FIRST
    setMessages(prev => [
      ...prev,
      { role: 'assistant', content: finalText || 'No response' },
    ]);

    //  MARK SESSION AS READY FOR HISTORY (THIS LINE)
    if (!hasSentFirstMessage) {
      setHasSentFirstMessage(true);
    }

  } catch (err) {
    console.error(err);
  } finally {
    setSending(false);
  }
};



  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        // bgcolor: '#E6F1C1',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <ChatHeader
        isDark={isDark}
        currDarkThemeClass={currDarkThemeClass}
      />

      {!sessionId && !isNewSession ? (
        <Box sx={{ flex: 1, display: 'grid', placeItems: 'center', background: '#f7faea' }}>
          <Button variant="contained" onClick={onNewChat}>
            Start New Chat
          </Button>
        </Box>
      ) : (
        <>
          <ChatMessages messages={messages} isThinking={sending} isDark={isDark} />
          <ChatInput onSend={handleSend} disabled={sending} sessionId={sessionId} isDark={isDark} />
        </>
      )}

    </Box>
  );
}
